/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */
import { Button, SxProps } from '@mui/material';
import { FC } from 'react';
import { headerPlayButtonSX } from '../styles/container';
import { useLocalization } from '@/data/Localization';
import LogoutIcon from '@mui/icons-material/Logout';
import { combineSX } from '@/utils/combineSX';

export const HeaderPlayButton: FC<{sx?:SxProps}> = ({sx}) => {
    const HeaderLabels = useLocalization('Header');
    return (
        <Button 
            sx={combineSX([headerPlayButtonSX, sx])}
            href={HeaderLabels.Actions.PlayButtonLink.t()}
            aria-label={HeaderLabels.Playbutton.t()} 
            target='_blank'
        >
            {HeaderLabels.Actions.PlayButton.t()}
            <LogoutIcon />
        </Button>
    );
};